import React from "react";
import FAQ from "./FAQ";
import { useT } from "hooks/useT";

export default function PricingFAQ() {
  const { t } = useT();

  const PRICING_FAQS = [
    { q: t("faq_pricing_1_q"), a: t("faq_pricing_1_a") },
    { q: t("faq_pricing_2_q"), a: t("faq_pricing_2_a") },
    { q: t("faq_pricing_3_q"), a: t("faq_pricing_3_a") },
    { q: t("faq_pricing_4_q"), a: t("faq_pricing_4_a") },
    { q: t("faq_pricing_5_q"), a: t("faq_pricing_5_a") },
    { q: t("faq_pricing_6_q"), a: t("faq_pricing_6_a") },
    { q: t("faq_pricing_7_q"), a: t("faq_pricing_7_a") },
  ];

  return (
    <FAQ
      faqs={PRICING_FAQS}
      title={t("faq_pricing_title")}
      subtitle={t("faq_pricing_subtitle")}
      darkmode={false}
    />
  );
}
